/*
 * @Descripttion: '路由配置'
 * @Author: lilong(lilong@hztianque.com)
 * @Date: 2020-07-16 17:12:45
 * @LastEditTime: 2021-04-28 09:28:30
 */
const legalDaily = () => import(/* webpackChunkName: "tpl" */'./views')
export default () => ({
  path: '/legalDaily',
  component: legalDaily,
  redirect: '/legalDaily/projectManagement',
  meta: { layout: 'navbar', title: '法制日报政法展' },
  children: [
    {
      path: 'projectManagement',
      component: () => import(/* webpackChunkName: "tpl" */'./views/children/projectManagement/index.vue'),
      name: 'ProjectManagement',
      meta: {
        title: '项目管理',
      },
    },
    {
      path: 'reportManagement',
      component: () => import(/* webpackChunkName: "tpl" */'./views/children/reportManagement/index.vue'),
      name: 'ReportManagement',
      meta: {
        title: '报名管理',
      },
    },
    {
      path: 'hotelManagement',
      component: () => import(/* webpackChunkName: "tpl" */'./views/children/hotelManagement/index.vue'),
      name: 'HotelManagement',
      meta: {
        title: '酒店管理',
      },
    },
  ],
})